export default class SubscriptionPlanCoverageType {}

// SubscriptionPlanCoverageType.Appointments = 'APPOINTMENTS';
// SubscriptionPlanCoverageType.Prescriptions = 'PRESCRIPTIONS';

// SubscriptionPlanCoverageType.DispensingFee = 'DISPENSING_FEE';
SubscriptionPlanCoverageType.TransferFee = 'TRANSFER_FEE';
// SubscriptionPlanCoverageType.ShippingFee = 'SHIPPING_FEE';

// Percentage
// SubscriptionPlanCoverageType.Comprehensive = 'COMPREHENSIVE';
SubscriptionPlanCoverageType.FleaAndTick = 'FLEA_AND_TICK';
